import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from 'common-libs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private _authService: AuthService, private _router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const token = this._authService.getAccessToken();

    // ✅ single consolidated auth check with early UrlTree return
    if (!token || this._authService.isTokenExpired(token)) {
      return this._router.createUrlTree(['/auth/signin']);
    }

    const requiredModule: string | undefined = route.data['module'];
    if (requiredModule) {
      const raw = localStorage.getItem('moduleList');
      if (raw) {
        const modulePermissions: any[] = JSON.parse(raw);
        const hasAccess = modulePermissions.some(
          item => item?.name?.toLowerCase() === requiredModule.toLowerCase()
        );
        if (!hasAccess) {
          return this._router.createUrlTree(['auth/error']); // ✅ UrlTree redirect
        }
      }
    }

    return true;
  }
}